export const GET_ADMIN_STORES_BEGIN = "GET_ADMIN_STORES_BEGIN";
export const GET_ADMIN_STORES_SUCCESS = "GET_ADMIN_STORES_SUCCESS";
export const GET_ADMIN_STORES_ERROR = "GET_ADMIN_STORES_ERROR";